import request from '@/utils/request'
export function fetchList(params) {
  return request({
    url:'/qr/advertisement/list',
    method:'get',
    params:params
  })
}
export function deleteAd(id) {
  return request({
    url:'/qr/advertisement/delete/' + id,
    method:'get',
  })
}
export function getAd(id) {
  return request({
    url:'/qr/advertisement/'+id,
    method:'get',
  })
}
export function creatAd(data) {
  return request({
    url:'/qr/advertisement/create',
    method:'post',
    data:data
  })
}
export function updateAd(id,data) {
  return request({
    url:'/qr/advertisement/update/'+id,
    method:'post',
    data:data
  })
}
export function updateStatus(id,data) {
  return request({
    url:'/qr/advertisement/updateStatus/'+id,
    method:'post',
    data:data
  })
}
export function uploadAdFile(data) {
  return request({
    url:'/qr/advertisement/uploadAdFile/',
    method:'post',
    data:data
  })
}
export function signCosUrl(url) {
  return request({
    url:'/qr/advertisement/signCosUrl',
    method:'get',
    params: { url }
  })
}



// WEBPACK FOOTER //
// ./src/api/qrAdvertise.js